import { useNavigate } from 'react-router-dom'

function DashboardEmpty() {
  const navigate = useNavigate()

  return (
    <>
      <div className="flex flex-col items-center justify-center h-full gap-4">
        <p className="text-xl font-bold">Let’s Get You Started</p>
        <p className="max-w-md text-center">
          Your dashboard will come to life once a device is enrolled. Start by adding your first members and enrolling their devices. Updates appear every 12 hours.
        </p>
        <div className="flex gap-2 py-2">
          <div
            onClick={() => navigate('/members')}
            className="min-h-8 px-3 bg-neutral-1 rounded border border-neutral-5 justify-center items-center gap-2 inline-flex cursor-pointer"
          >
            <div className="text-neutral-12 text-sm leading-tight">Add Members</div>
          </div>
          <div
            onClick={() => navigate('/devices')}
            className="min-h-8 px-3 bg-neutral-1 rounded border border-neutral-5 justify-center items-center gap-2 inline-flex cursor-pointer"
          >
            <div className="text-neutral-12 text-sm leading-tight">Enrol Devices</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DashboardEmpty
